// Batch GET endpoints pass ids in the query string, so a large id set can blow past
// server/proxy request-line limits (~8KB → HTTP 414). Split ids into chunks small
// enough to keep each URL safe and fetch them in parallel.
const DEFAULT_CHUNK_SIZE = 100;

export const chunk = <T>(items: T[], size = DEFAULT_CHUNK_SIZE): T[][] => {
  const chunks: T[][] = [];
  for (let index = 0; index < items.length; index += size) {
    chunks.push(items.slice(index, index + size));
  }
  return chunks;
};

export const fetchInChunks = async <TId, TResult>(
  ids: TId[],
  fetch: (idsChunk: TId[]) => Promise<TResult[]>,
  size = DEFAULT_CHUNK_SIZE
): Promise<TResult[]> => {
  if (ids.length === 0) {
    return [];
  }
  const pages = await Promise.all(chunk(ids, size).map(fetch));
  return pages.flat();
};
